import { render } from "./SelecionarTipoCusto.vue?vue&type=template&id=2f13dab6&scoped=true&ts=true"
import script from "./SelecionarTipoCusto.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoCusto.vue?vue&type=script&lang=ts"

import "./SelecionarTipoCusto.vue?vue&type=style&index=0&id=2f13dab6&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f13dab6"]])

export default __exports__